import { createSlice } from '@reduxjs/toolkit'

const initialInvoiceProduct = {
    product_name: '',
    product_unit: '',
    l15: '',
    kg: '',
    lit: '',
    gallon: '',
    note: '',
    price_unit: '',
    amount: '',
    product_id: '',
    price_id: '',
    price_no: '',
}
const initialState = {
    stage: 0,
    selectedCustomer: '',
    serial: '',
    startTime: '',
    endTime: '',
    valid_date: '',
    inventory: '',
    selectedSO: '',
    selectedTickets: [],
    note: '',
    saletype: null,
    loadingtype: null,
    so_data: undefined,
    invoice_products: [initialInvoiceProduct],
    priceData: '',
}
export const batchTicket = createSlice({
    name: 'Create Batch Ticket',
    initialState,
    reducers: {
        // Redux Toolkit allows us to write "mutating" logic in reducers. It
        // doesn't actually mutate the state because it uses the Immer library,
        // which detects changes to a "draft state" and produces a brand new
        // immutable state based off those changes
        setCreateBatchTicketState: (state, action) => {
            state[action.payload.state] = action.payload.value
        },
        updateInvoiceProducts: (state, action) => {       //update product,  nhan 3 tham so lan luot la index: index trong array, key: ten key cua object can update, value: gia tri moi cua key
            state.invoice_products[action.payload.index][action.payload.key] = action.payload.value
        },
        resetBatchTicket: () => ({...initialState}) 
    }
})

// Action creators are generated for each case reducer function
export const { setCreateBatchTicketState, updateInvoiceProducts } = batchTicket.actions

export default batchTicket.reducer